import React, { Component, createRef } from "react";

import {
  CCol,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CPagination
} from "@coreui/react";
import { Switch } from "@material-ui/core";
import {
  EllipsisVertical,
  Copy,
  Heart,
  HeartOff,
  FileText,
  SlidersHorizontal,
  ChevronDown
} from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import LessonPlanModal from "./LessonPlanModal";
import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Breadcrumb from "../Breadcrumb";
import { ContentCard } from "../ContentCard";
import Loading from "../Loading";
import ProtectedRoute from "../ProtectedRoute";
import "./css/libraryCurriculum.css";

const selectPortalStyles = {
  menuPortal: base => ({ ...base, zIndex: 1050 })
};

// Ícones por tipo (mesmos do mock)
const typeIcons = {
  all: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.8" />
    </svg>
  ),
  aula: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <path d="M3.5 6.5h17v10h-17z" strokeLinejoin="round" />
      <path d="M9 20.5h6M12 16.5v4" strokeLinecap="round" />
    </svg>
  ),
  atividade: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <path d="M9 11l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
    </svg>
  ),
  avaliacao: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <path
        d="M8 4h8l4 4v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z"
        strokeLinejoin="round"
      />
      <path d="M9 12h6M9 16h6" strokeLinecap="round" />
    </svg>
  ),
  livro: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <path
        d="M4 5.5C6 4.5 9 4.5 12 6c3-1.5 6-1.5 8-.5v13c-2-1-5-1-8 .5-3-1.5-6-1.5-8-.5v-13Z"
        strokeLinejoin="round"
      />
      <path d="M12 6v13" />
    </svg>
  ),
  video: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="3.5" y="5.5" width="13" height="13" rx="3" />
      <path d="M17 10l4-2.3v8.6L17 14" strokeLinejoin="round" />
    </svg>
  ),
  jogo: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="2.5" y="8" width="19" height="9" rx="4.5" />
      <path d="M7 10.5v4M5 12.5h4" strokeLinecap="round" />
      <circle cx="16" cy="11" r="1" fill="currentColor" />
      <circle cx="18.3" cy="13.3" r="1" fill="currentColor" />
    </svg>
  ),
  simulado: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="4" y="3.5" width="16" height="17" rx="2" />
      <circle cx="9" cy="9" r="1.6" />
      <circle cx="9" cy="14" r="1.6" />
      <path d="M13 9h5M13 14h5" strokeLinecap="round" />
    </svg>
  ),
  projeto: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path
        d="M12 3l3 5h6l-4.5 4 1.7 6-6.2-3.5L5.8 18l1.7-6L3 8h6z"
        strokeLinejoin="round"
      />
    </svg>
  ),
  podcast: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="9" y="3.5" width="6" height="10" rx="3" />
      <path d="M6 12a6 6 0 0 0 12 0M12 18v3" strokeLinecap="round" />
    </svg>
  ),
  infografico: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M5 20V10M12 20V4M19 20v-7" strokeLinecap="round" />
    </svg>
  ),
  slide: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="3" y="5" width="18" height="12" rx="2" />
      <path d="M8 20.5h8" strokeLinecap="round" />
      <path
        d="M7 13l3-3 2.5 2.5L17 8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  redacao: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <path
        d="M4 20l1-4L16.5 4.5a1.4 1.4 0 0 1 2 0l1.5 1.5a1.4 1.4 0 0 1 0 2L8.5 19.5 4 20Z"
        strokeLinejoin="round"
      />
    </svg>
  )
};

// Ícones por disciplina (cores e ícones – iguais ao mock)
const subjectMap = {
  hist: { name: "História", color: "#E07B27", soft: "#FCEEE1", short: "H" },
  port: {
    name: "Língua Portuguesa",
    color: "#2F80ED",
    soft: "#E9F1FE",
    short: "LP"
  },
  mat: { name: "Matemática", color: "#6C5CE7", soft: "#EFEBFD", short: "M" },
  geo: { name: "Geografia", color: "#109C7F", soft: "#E2F6F1", short: "G" },
  sci: { name: "Ciências", color: "#E0468A", soft: "#FCE7F0", short: "C" }
};

const subjectIcons = {
  hist: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 6h16M4 6c0 2-1.5 3-1.5 3M4 6c0 2 1.5 3 1.5 3M20 6c0 2 1.5 3 1.5 3M20 6c0 2-1.5 3-1.5 3M12 6v13M8 19h8"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  port: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 5.5C6 4.5 9 4.5 12 6c3-1.5 6-1.5 8-.5v13c-2-1-5-1-8 .5-3-1.5-6-1.5-8-.5v-13Z"
        stroke="white"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M12 6v13" stroke="white" strokeWidth="1.8" />
    </svg>
  ),
  mat: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4h14v3l-5.5 5L19 17v3H5v-3l5.5-5L5 7V4Z"
        stroke="white"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  ),
  geo: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="8.5" stroke="white" strokeWidth="1.8" />
      <path
        d="M3.5 12h17M12 3.5c2.5 2.3 3.8 5.3 3.8 8.5s-1.3 6.2-3.8 8.5c-2.5-2.3-3.8-5.3-3.8-8.5s1.3-6.2 3.8-8.5Z"
        stroke="white"
        strokeWidth="1.8"
      />
    </svg>
  ),
  sci: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 3h6M10 3v6.5L4.8 18a2 2 0 0 0 1.7 3h11a2 2 0 0 0 1.7-3L14 9.5V3"
        stroke="white"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M7.5 15h9" stroke="white" strokeWidth="1.8" />
    </svg>
  )
};

// Labels de tipo (para o filtro)
const typeLabels = {
  all: "Todos",
  aula: "Aula",
  atividade: "Atividade",
  avaliacao: "Avaliação",
  livro: "Livro",
  video: "Vídeo",
  jogo: "Jogo",
  simulado: "Simulado",
  projeto: "Projeto",
  podcast: "Podcast",
  infografico: "Infográfico",
  slide: "Slide",
  redacao: "Redação"
};

// Estilo único para todos os <select> da sidebar
const nativeSelectStyle = {
  width: "100%",
  height: "42px",
  lineHeight: "1.2",
  padding: "0 26px 0 14px",
  borderRadius: "12px",
  border: "1.5px solid #E7E4F2",
  background: "#F6F5FB",
  fontFamily: "'Inter', sans-serif",
  fontSize: "14px",
  fontWeight: 600,
  color: "#211D3A",
  appearance: "none",
  boxSizing: "border-box",
  cursor: "pointer",
  transition: "border-color .12s ease"
};

class Biblioteca extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      content: [],
      favorites: [],
      favoritesFilter: false,
      currentPage: 1,
      maxPages: 1,
      itemsCount: 0,
      maxItems: 16,
      filter: {
        word: "",
        type: { id: 0, name: "Todos" },
        segment: null,
        serie: null,
        discipline: null,
        thematic_unit: null,
        curriculo: null,
        livro: null
      },
      segments: [],
      typeOptions: [{ id: 0, name: "Todos" }],
      segmentOptions: [],
      serieOptions: [],
      disciplineOptions: [],
      thematicUnitOptions: [],
      curriculoOptions: [],
      livroOptions: [],
      lessonPlanModalOpen: false,
      selectedLessonPlanId: null,
      // Só tem efeito abaixo de 992px, onde a barra de filtros fica recolhida
      // (css/libraryCurriculum.css). No desktop ela está sempre à vista.
      filtrosAbertos: false
    };
    this.timeToUpdate = createRef(3);
    this.countdown = null;
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.loadInitialData();
    this.getFavorites();
    this.restoreFilters();
  }

  componentWillUnmount() {
    clearInterval(this.countdown);
  }

  restoreFilters = () => {
    const saved = localStorage.getItem("biblioteca_filters");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.setState(prev => ({
          filter: { ...prev.filter, ...parsed },
          favoritesFilter: parsed.favoritesFilter || false
        }));
      } catch (e) {
        // ignore
      }
    }
  };

  saveFilters = () => {
    localStorage.setItem(
      "biblioteca_filters",
      JSON.stringify({
        ...this.state.filter,
        favoritesFilter: this.state.favoritesFilter
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevState.filter) !== JSON.stringify(this.state.filter) ||
      prevState.favoritesFilter !== this.state.favoritesFilter
    ) {
      this.saveFilters();
    }
    if (
      this.state.filter.word !== prevState.filter.word &&
      this.state.filter.word === ""
    ) {
      this.fetchContent();
    }
  }

  loadInitialData = async () => {
    this.setState({ loading: true });
    try {
      const typesResp = await axios.get(`${URL.api}content/type/list`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      });
      const types = typesResp.data.data
        .filter(item => item.content === true)
        .map(item => ({ id: item.id, name: item.name }));
      const typeOptions = [{ id: 0, name: "Todos" }, ...types];

      const segmentsResp = await axios.get(
        `${URL.api}content/los/filterStructureObjective/${
          this.state.filter.type?.id || 0
        }`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      const segments = segmentsResp.data.data;

      const curriculosResp = await axios.get(
        `${URL.api}curriculos/grupos/list`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      const curriculoData = curriculosResp.data.data || [];
      const curriculoOptions = curriculoData
        .filter(item => item.tipo_id === 1)
        .map(item => ({
          value: item.curriculo_id,
          label: item.curriculo_nome || item.nome || "Currículo sem nome"
        }));

      const livroOptions = curriculoData
        .filter(item => item.tipo_id === 2)
        .map(item => ({
          value: item.curriculo_id,
          label: item.curriculo_nome || item.nome || "Livro sem nome"
        }));

      this.setState(
        {
          typeOptions,
          segments,
          curriculoOptions,
          livroOptions
        },
        () => {
          this.deriveOptions();
          this.fetchContent();
        }
      );
    } catch (error) {
      toastr.error("Falha", "Não foi possível carregar os dados");
      this.setState({ loading: false });
    }
  };

  deriveOptions = () => {
    const { segments, filter } = this.state;

    const segmentOptions = segments
      .sort((a, b) => a.order - b.order)
      .map(item => ({ value: item.id, label: item.name }));

    let serieOptions = [];
    if (filter.segment?.value) {
      const segment = segments.find(s => s.id === filter.segment.value);
      if (segment) {
        serieOptions = segment.series
          .sort((a, b) => a.order - b.order)
          .map(s => ({ value: s.id, label: s.name }));
      }
    } else {
      const allSeries = segments.reduce(
        (acc, seg) =>
          acc.concat(seg.series.map(s => ({ ...s, segId: seg.id }))),
        []
      );
      serieOptions = allSeries
        .sort((a, b) => a.segId * 100 + a.order - (b.segId * 100 + b.order))
        .map(s => ({ value: s.id, label: s.name }));
    }

    let disciplineOptions = [];
    if (filter.serie?.value) {
      const serie = segments
        .reduce((acc, seg) => acc.concat(seg.series), [])
        .find(s => s.id === filter.serie.value);
      if (serie) {
        disciplineOptions = serie.disciplines
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(d => ({ value: d.id, label: d.name }));
      }
    } else {
      const allDisciplines = segments
        .reduce((acc, seg) => acc.concat(seg.series), [])
        .reduce((acc, serie) => acc.concat(serie.disciplines), [])
        .filter((d, idx, self) => self.findIndex(x => x.id === d.id) === idx)
        .sort((a, b) => a.name.localeCompare(b.name));
      disciplineOptions = allDisciplines.map(d => ({
        value: d.id,
        label: d.name
      }));
    }

    // Sem filtro de disciplina aqui: quem decide as disciplinas do grupo é o
    // backend (content/los/filterStructureObjective), pelo educational_discipline_id
    // dos módulos. Havia um segundo filtro que comparava o NOME da disciplina com o
    // nome de TODOS os módulos do usuário (user_modules traz segmento, Gameficandus
    // etc.). Em grupo sem módulo de disciplina — 67 dos 91 de homologação em
    // 28/09/2026 — o backend manda todas as disciplinas e esse filtro descartava
    // todas: "Componente curricular" ficava sem opção.

    let thematicUnitOptions = [];
    if (filter.discipline?.value) {
      const discipline = segments
        .reduce((acc, seg) => acc.concat(seg.series), [])
        .reduce((acc, serie) => acc.concat(serie.disciplines), [])
        .find(d => d.id === filter.discipline.value);
      if (discipline) {
        const objectives = discipline.objectives || [];
        thematicUnitOptions = objectives.map(obj => ({
          value: obj.id,
          label: obj.description
        }));
      }
    } else {
      const allObjectives = segments
        .reduce((acc, seg) => acc.concat(seg.series), [])
        .reduce((acc, serie) => acc.concat(serie.disciplines), [])
        .reduce((acc, disc) => acc.concat(disc.objectives || []), [])
        .filter(
          (obj, idx, self) => self.findIndex(x => x.id === obj.id) === idx
        );
      thematicUnitOptions = allObjectives
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map(obj => ({ value: obj.id, label: obj.description }));
    }

    this.setState({
      segmentOptions,
      serieOptions,
      disciplineOptions,
      thematicUnitOptions
    });
  };

  getFavorites = async () => {
    try {
      const resp = await axios.get(`${URL.api}content/favorites/list`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      });
      this.setState({ favorites: resp.data.data.map(f => f.lo_id) });
    } catch (e) {
      // ignore
    }
  };

  toggleFavorite = async id => {
    const { favorites } = this.state;
    const isFav = favorites.includes(id);
    try {
      if (isFav) {
        await axios.delete(`${URL.api}content/favorites/deleteByLoId/${id}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        });
        this.setState({ favorites: favorites.filter(f => f !== id) });
      } else {
        await axios.post(
          `${URL.api}content/favorites/insert`,
          { lo_id: id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        );
        this.setState({ favorites: [...favorites, id] });
      }
    } catch (error) {
      toastr.error("Erro", "Não foi possível alterar favorito");
    }
  };

  fetchContent = async () => {
    this.setState({ loading: true });
    const { filter, favoritesFilter, currentPage, maxItems } = this.state;
    const params = {
      type: filter.type?.id !== 0 ? filter.type?.id : null,
      word: filter.word || null,
      segment: filter.segment?.value || null,
      serie: filter.serie?.value || null,
      discipline: filter.discipline?.value || null,
      thematic_unit: filter.thematic_unit?.value || null,
      ccurriculos: filter.curriculo ? [filter.curriculo.value] : [],
      livros: filter.livro ? [filter.livro.value] : [],
      private: false,
      favorites: favoritesFilter
    };

    try {
      const resp = await axios.post(
        `${URL.api}content/los/listLibraryFilterCurriculum?page=${currentPage}&page_size=${maxItems}`,
        params,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      const data = resp.data.data || [];
      const meta = resp.data.meta || {};
      this.setState({
        content: data,
        currentPage: meta.current_page || 1,
        maxPages: meta.last_page || 1,
        itemsCount: meta.total || 0,
        loading: false
      });
    } catch (error) {
      toastr.error("Erro", "Não foi possível carregar os conteúdos");
      this.setState({ loading: false });
    }
  };

  changeFilter = (key, value) => {
    this.setState(
      prev => ({ filter: { ...prev.filter, [key]: value } }),
      () => {
        if (key === "segment") {
          this.setState(
            prev => ({
              filter: {
                ...prev.filter,
                serie: null,
                discipline: null,
                thematic_unit: null
              }
            }),
            () => {
              this.deriveOptions();
              this.fetchContent();
            }
          );
        } else if (key === "serie") {
          this.setState(
            prev => ({
              filter: { ...prev.filter, discipline: null, thematic_unit: null }
            }),
            () => {
              this.deriveOptions();
              this.fetchContent();
            }
          );
        } else if (key === "discipline") {
          this.setState(
            prev => ({ filter: { ...prev.filter, thematic_unit: null } }),
            () => {
              this.deriveOptions();
              this.fetchContent();
            }
          );
        } else {
          this.deriveOptions();
          this.fetchContent();
        }
      }
    );
  };

  handleSearchChange = e => {
    const value = e.target.value;
    this.setState(prev => ({ filter: { ...prev.filter, word: value } }));
    clearInterval(this.countdown);
    this.timeToUpdate.current = 3;
    this.countdown = setInterval(() => {
      this.timeToUpdate.current -= 1;
      if (this.timeToUpdate.current === 0) {
        clearInterval(this.countdown);
        this.fetchContent();
      }
    }, 1000);
  };

  handlePageChange = page => {
    this.setState({ currentPage: page }, () => this.fetchContent());
  };

  openLessonPlanModal = id => {
    this.setState({ lessonPlanModalOpen: true, selectedLessonPlanId: id });
  };

  closeLessonPlanModal = () => {
    this.setState({ lessonPlanModalOpen: false, selectedLessonPlanId: null });
  };

  handleCopyLink = content => {
    const url = window.location.href.split("/");
    navigator.clipboard.writeText(
      `${url[0]}//${url[2]}/content/view/${content.id}`
    );
    toastr.success("Link copiado", "Link copiado para a área de transferência");
  };

  handleOpenPDF = content => {
    if (content.pdf_path) window.open(content.pdf_path, "_blank");
  };

  isNew = content => {
    const today = new Date();
    const diffDays = Math.ceil(
      (today - new Date(content.updated_at)) / (1000 * 60 * 60 * 24)
    );
    return diffDays < 30;
  };

  render() {
    const {
      loading,
      content,
      favoritesFilter,
      favorites,
      currentPage,
      maxPages,
      itemsCount,
      filter,
      typeOptions,
      segmentOptions,
      serieOptions,
      disciplineOptions,
      thematicUnitOptions,
      curriculoOptions,
      livroOptions,
      lessonPlanModalOpen,
      selectedLessonPlanId,
      filtrosAbertos
    } = this.state;

    // Filtros da barra lateral em uso (o tipo "Todos" tem id 0). Aparece no
    // botão "Filtros" do mobile, onde a barra fica recolhida.
    const filtrosAtivos = [
      filter.type?.id,
      filter.segment,
      filter.serie,
      filter.discipline,
      filter.curriculo,
      filter.livro,
      filter.thematic_unit
    ].filter(Boolean).length;

    const hasLessonPlanModule = this.props.user?.user_modules?.some(
      module => module.name === "Planos de aula" || module.id === 112
    );

    const flatContent = content.reduce(
      (acc, group) =>
        acc.concat(
          (group.content || []).map(item => ({ ...item, type_id: group.id }))
        ),
      []
    );

    return (
      <div
        style={{
          width: "100%",
          fontFamily: "'Inter', sans-serif",
          color: "#211D3A",
          backgroundColor: "#FFFFFF",
          minHeight: "100vh"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "28px",
            gap: "20px",
            flexWrap: "wrap"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "11px",
                background: "linear-gradient(135deg, #6C5CE7, #2F80ED)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontFamily: "'Baloo 2', sans-serif",
                fontWeight: 800,
                fontSize: "18px",
                flexShrink: 0
              }}
            >
              B
            </div>
            <div>
              <div
                style={{
                  fontFamily: "'Baloo 2', sans-serif",
                  fontWeight: 700,
                  fontSize: "19px",
                  color: "#211D3A"
                }}
              >
                Biblioteca
              </div>
              <div
                style={{
                  fontSize: "11.5px",
                  color: "#6A6580",
                  marginTop: "-2px"
                }}
              >
                Conteúdos pedagógicos
              </div>
            </div>
          </div>
          {/* Base de 280px: em tela estreita a busca desce para a linha de
              baixo e ocupa a largura toda, em vez de encolher ao lado do
              título até ~120px. */}
          <div
            style={{
              flex: "1 1 280px",
              maxWidth: "440px",
              position: "relative"
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                position: "absolute",
                left: "14px",
                top: "50%",
                transform: "translateY(-50%)",
                opacity: 0.45
              }}
            >
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Pesquisar aulas, temas, códigos BNCC..."
              style={{
                width: "100%",
                padding: "12px 16px 12px 42px",
                borderRadius: "14px",
                border: "1.5px solid #E7E4F2",
                background: "#FFFFFF",
                fontFamily: "'Inter', sans-serif",
                fontSize: "14px",
                color: "#211D3A",
                outline: "none",
                transition: "border-color .15s ease, box-shadow .15s ease"
              }}
              value={filter.word || ""}
              onChange={this.handleSearchChange}
            />
          </div>
        </div>

        {/* Cabeçalho */}
        <div
          className="lib-barra"
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            marginBottom: "22px",
            flexWrap: "wrap",
            gap: "14px"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "13.5px",
              color: "#6A6580",
              fontWeight: 500
            }}
          >
            Meus Favoritos
            <div
              style={{
                width: "40px",
                height: "23px",
                borderRadius: "20px",
                background: favoritesFilter ? "#6C5CE7" : "#E7E4F2",
                position: "relative",
                cursor: "pointer",
                transition: "background .15s ease",
                flexShrink: 0
              }}
              onClick={() => {
                // Volta à página 1: os favoritos cabem em poucas páginas, e
                // ficar na 5ª mostraria a lista vazia.
                this.setState(
                  prev => ({
                    favoritesFilter: !prev.favoritesFilter,
                    currentPage: 1
                  }),
                  () => this.fetchContent()
                );
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "2.5px",
                  left: favoritesFilter ? "19.5px" : "2.5px",
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "white",
                  boxShadow: "0 1px 3px rgba(0,0,0,.25)",
                  transition: "left .15s ease"
                }}
              />
            </div>
          </div>
          <button
            type="button"
            className="lib-filtros-toggle"
            aria-expanded={filtrosAbertos}
            aria-controls="lib-filtros"
            onClick={() =>
              this.setState(prev => ({ filtrosAbertos: !prev.filtrosAbertos }))
            }
          >
            <SlidersHorizontal size={16} />
            Filtros
            {filtrosAtivos > 0 && (
              <span className="lib-filtros-qtd">{filtrosAtivos}</span>
            )}
            <ChevronDown size={16} className="lib-filtros-seta" />
          </button>
        </div>

        {/* Layout com sidebar */}
        <div
          className="lib-layout"
          style={{
            display: "grid",
            gridTemplateColumns: "320px 1fr",
            gap: "28px",
            alignItems: "start"
          }}
        >
          {/* Sidebar */}
          <aside
            id="lib-filtros"
            className={`lib-filtros${
              filtrosAbertos ? " lib-filtros--aberto" : ""
            }`}
            style={{
              background: "#FFFFFF",
              border: "1px solid #E7E4F2",
              borderRadius: "18px",
              padding: "20px 18px",
              position: "sticky",
              top: "20px"
            }}
          >
            {/* Tipo de conteúdo */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Tipo de conteúdo
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  maxHeight: "230px",
                  overflowY: "auto",
                  paddingRight: "4px"
                }}
              >
                {typeOptions.map(type => {
                  const isActive = filter.type?.id === type.id;
                  const icon =
                    typeIcons[type.name.toLowerCase()] || typeIcons.all;
                  return (
                    <div
                      key={type.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "8px 9px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "13.5px",
                        fontWeight: 600,
                        color: isActive ? "#6C5CE7" : "#211D3A",
                        background: isActive ? "#EFEBFD" : "transparent",
                        transition: "background .12s ease"
                      }}
                      onClick={() => {
                        this.setState(
                          prev => ({ filter: { ...prev.filter, type } }),
                          () => this.fetchContent()
                        );
                      }}
                    >
                      <span style={{ width: 17, height: 17 }}>{icon}</span>
                      {type.name}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Segmento */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Segmento
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.segment?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = segmentOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.changeFilter("segment", option || null);
                }}
              >
                <option value="">Todos</option>
                {segmentOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Série */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Série
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.serie?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = serieOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.changeFilter("serie", option || null);
                }}
              >
                <option value="">Todas</option>
                {serieOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Componente curricular */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Componente curricular
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.discipline?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = disciplineOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.changeFilter("discipline", option || null);
                }}
              >
                <option value="">Todos</option>
                {disciplineOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Currículo (multi) */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Currículo
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.curriculo?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = curriculoOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.setState(
                    prev => ({
                      filter: { ...prev.filter, curriculo: option || null }
                    }),
                    () => this.fetchContent()
                  );
                }}
              >
                <option value="">Todos</option>
                {curriculoOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Livro (multi) */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Livro
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.livro?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = livroOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.setState(
                    prev => ({
                      filter: { ...prev.filter, livro: option || null }
                    }),
                    () => this.fetchContent()
                  );
                }}
              >
                <option value="">Todos</option>
                {livroOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Eixo temático */}
            <div style={{ marginBottom: "22px" }}>
              <h3
                style={{
                  fontSize: "11.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#6A6580",
                  fontWeight: 700,
                  margin: "0 0 10px"
                }}
              >
                Eixo temático
              </h3>
              <select
                style={nativeSelectStyle}
                value={filter.thematic_unit?.value || ""}
                onChange={e => {
                  const val = e.target.value;
                  const option = thematicUnitOptions.find(
                    o => o.value === parseInt(val)
                  );
                  this.changeFilter("thematic_unit", option || null);
                }}
              >
                <option value="">Eixo BNCC</option>
                {thematicUnitOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </aside>

          {/* Conteúdo principal */}
          <main>
            <div
              style={{
                fontSize: "13px",
                color: "#6A6580",
                marginBottom: "14px",
                fontWeight: 500
              }}
            >
              Exibindo {flatContent.length} de {itemsCount} conteúdos
            </div>

            {loading ? (
              <Loading />
            ) : flatContent.length > 0 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                  gap: "18px"
                }}
              >
                {flatContent.map((item, idx) => {
                  const isFav = favorites.includes(item.id);
                  let subjectKey = "mat";
                  const discName = (item.discipline_name || "").toLowerCase();
                  if (discName.includes("história")) subjectKey = "hist";
                  else if (
                    discName.includes("língua") ||
                    discName.includes("portuguesa")
                  )
                    subjectKey = "port";
                  else if (discName.includes("geografia")) subjectKey = "geo";
                  else if (discName.includes("ciências")) subjectKey = "sci";
                  const subject = subjectMap[subjectKey] || subjectMap.mat;
                  const icon = subjectIcons[subjectKey] || subjectIcons.mat;

                  return (
                    <div
                      key={`${item.id}-${idx}`}
                      className="position-relative d-flex"
                    >
                      <ContentCard.Root titleLink={`/content/view/${item.id}`}>
                        <ContentCard.Banner
                          fallbackColor={subject.color}
                          fallbackIcon={
                            typeIcons[item.type_name?.toLowerCase()] ||
                            typeIcons.all
                          }
                          badge={this.isNew(item) ? "Novo" : ""}
                          image={item.image}
                        />
                        <ContentCard.Main>
                          <ContentCard.Header title={item.name}>
                            <ContentCard.Item>
                              <p className="text-muted mb-0">
                                {item.discipline_name}
                                {item.ability_code &&
                                  ` • (${item.ability_code})`}
                              </p>
                            </ContentCard.Item>
                          </ContentCard.Header>
                        </ContentCard.Main>
                      </ContentCard.Root>
                      <CDropdown className="context">
                        <CDropdownToggle
                          caret={false}
                          className="contextToggle rounded-circle btn-sm p-3"
                        >
                          <EllipsisVertical size={18} />
                        </CDropdownToggle>
                        <CDropdownMenu placement="top-end">
                          <CDropdownItem
                            className="text-dark"
                            onClick={() => this.toggleFavorite(item.id)}
                          >
                            {isFav ? (
                              <HeartOff size={18} className="mr-2" />
                            ) : (
                              <Heart size={18} className="mr-2" />
                            )}
                            {isFav
                              ? "Remover dos favoritos"
                              : "Adicionar aos favoritos"}
                          </CDropdownItem>
                          <hr />
                          <CDropdownItem
                            className="text-dark"
                            onClick={() => this.handleCopyLink(item)}
                          >
                            <Copy size={18} className="mr-2" />
                            Copiar link
                          </CDropdownItem>
                          {item.pdf_path && (
                            <CDropdownItem
                              className="text-dark"
                              onClick={() => this.handleOpenPDF(item)}
                            >
                              <FileText size={18} className="mr-2" />
                              Baixar livro digital
                            </CDropdownItem>
                          )}
                          {item.lesson_plan_id && hasLessonPlanModule && (
                            <CDropdownItem
                              className="text-dark"
                              onClick={() =>
                                this.openLessonPlanModal(item.lesson_plan_id)
                              }
                            >
                              <FileText size={18} className="mr-2" />
                              Acessar plano de aula
                            </CDropdownItem>
                          )}
                        </CDropdownMenu>
                      </CDropdown>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-muted p-4 d-flex justify-content-center">
                Nenhum conteúdo encontrado
              </div>
            )}

            {itemsCount > 0 && (
              <div className="row mt-4 mb-4 align-items-center">
                <div className="col-12 col-md-4 text-muted text-center text-md-left mb-2 mb-md-0">
                  <span>Total: {itemsCount}</span>
                </div>
                <div className="col-12 col-md-8 d-flex justify-content-center justify-content-md-end lib-paginacao">
                  <CPagination
                    activePage={currentPage}
                    pages={maxPages}
                    onActivePageChange={this.handlePageChange}
                  />
                </div>
              </div>
            )}
          </main>
        </div>

        <LessonPlanModal
          isOpen={lessonPlanModalOpen}
          onClose={this.closeLessonPlanModal}
          lessonPlanId={selectedLessonPlanId}
          userToken={this.props.user.token}
          // Se o modal aceitar fullScreen, passe a prop:
          fullScreen
          // Caso contrário, adicione um className para customizar via CSS:
          // className="fullscreen-modal"
        />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Biblioteca);
